/* eslint-disable react/jsx-max-depth */
import { Button, Card, Group, Text } from '@mantine/core';
import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import dompurify from 'dompurify';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import styles from './styles.scoped.css';
import IcEdit from '../../components/icons/IcEdit';
import IcVisibility from '../../components/icons/IcVisibility';
import IcDelete from '../../components/icons/IcDelete';

export default function SortableCard({ id, item, onClickDetail,
  onClickDelete, onClickUpdate, isSearchActive }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id, disabled: isSearchActive });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  };

  const contentStyle = {
    flex: 1,
    ...(isSearchActive ? { marginLeft: '16px' } : {})
  };

  return (
    <Card
      className={styles.sortableCard}
      data-dragging={isDragging}
      padding="6px 8px"
      ref={setNodeRef}
      style={style}
      sx={{ border: '1px solid #D9DEE4', borderRadius: '5px' }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {!isSearchActive && (
          <div className={styles.dragHandle} {...attributes} {...listeners}>
            <svg fill="currentColor" height="20" viewBox="0 0 20 20" width="20">
              <path d="M7 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 2zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 14zm6-8a2 2 0 1 0-.001-4.001A2 2 0 0 0 13 6zm0 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 14z" />
            </svg>
          </div>
        )}
        {!isSearchActive && (
          <div className={styles['order-number']}>
            {item.orderNumber || '1'}
          </div>
        )}
        <div className={styles.content} style={contentStyle}>
          <Text weight={500}>{item.question}</Text>
          <Text className={styles['answer-text']} color="dimmed" size="sm">
            {parse(dompurify.sanitize(item.answer, {
              ALLOWED_TAGS: ['p', 'b', 'i', 'em', 'strong', 'u', 'br'],
              ALLOWED_ATTR: []
            }))}
          </Text>
        </div>
        <Group className={styles['action-buttons']} spacing={4}>
          <Button
            onClick={onClickDetail}
            p={8}
            sx={() => ({
              width: 40,
              backgroundColor: 'var(--primary-color)',
              transition: 'opacity 0.2s ease',
              '&:hover': {
                backgroundColor: 'var(--primary-color)',
                opacity: 0.8,
              }
            })}
            variant="filled"
          >
            <IcVisibility />
          </Button>
          <Button
            onClick={onClickUpdate}
            p={8}
            sx={() => ({
              width: 40,
              backgroundColor: 'var(--primary-color)',
              transition: 'opacity 0.2s ease',
              '&:hover': {
                backgroundColor: 'var(--primary-color)',
                opacity: 0.8,
              }
            })}
            variant="filled"
          >
            <IcEdit />
          </Button>
          <Button
            onClick={onClickDelete}
            p={8}
            sx={() => ({
              width: 40,
              backgroundColor: 'var(--error-500-color)',
              transition: 'opacity 0.2s ease',
              '&:hover': {
                backgroundColor: 'var(--error-500-color)',
                opacity: 0.8,
              }
            })}
            variant="filled"
          >
            <IcDelete />
          </Button>
        </Group>
      </div>
    </Card>
  );
}

SortableCard.propTypes = {
  id: PropTypes.string.isRequired,
  isSearchActive: PropTypes.bool,
  item: PropTypes.object.isRequired,
  onClickDelete: PropTypes.func,
  onClickDetail: PropTypes.func,
  onClickUpdate: PropTypes.func,
};

